import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CalendarModule} from 'primeng/components/calendar/calendar';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { TurnoComponent } from './home/turno/turno.component';
import { UrgenciasComponent } from './home/urgencias/urgencias.component';
import { OrderPipe } from './pipes/order.pipe';
import { TurnosComponent } from './turnos/turnos.component';
import { CargaComponent } from './carga/carga.component';
import { BarriosComponent } from './carga/barrios/barrios.component';
import { OsComponent } from './carga/os/os.component';
import { CentrosComponent } from './carga/centros/centros.component';
import { ProfesionalesComponent } from './carga/profesionales/profesionales.component';
import { BackComponent } from './common/back/back.component';
import { EditarProfesionalComponent } from './carga/profesionales/editar-profesional/editar-profesional.component';
import { LoadingComponent } from './common/loading/loading.component';
import { ZonasComponent } from './carga/zonas/zonas.component';
import { ProfesionalesSearchComponent } from './home/profesionales-search/profesionales-search.component';
import { TurnosDadosComponent } from './home/turnos-dados/turnos-dados.component';

import {ShareService} from './services/share.service';
import { FechasComponent } from './home/fechas/fechas.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    TurnoComponent,
    UrgenciasComponent,
    OrderPipe,
    TurnosComponent,
    CargaComponent,
    BarriosComponent,
    OsComponent,
    CentrosComponent,
    ProfesionalesComponent,
    BackComponent,
    EditarProfesionalComponent,
    LoadingComponent,
    ZonasComponent,
    ProfesionalesSearchComponent,
    TurnosDadosComponent,
    FechasComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    NgbModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    CalendarModule
  ],
  providers: [ShareService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/app.module.ts